const MUTATING = new Set(['post', 'put', 'patch', 'delete']);
const GET_DELAY_MS = 200;

let pending = 0;
let visible = false;
let showTimer = null;
const listeners = new Set();

const emit = () => {
  listeners.forEach((listener) => listener(visible));
};

const setVisible = (next) => {
  if (visible === next) return;
  visible = next;
  emit();
};

export const subscribeGlobalLoading = (listener) => {
  listeners.add(listener);
  listener(visible);
  return () => listeners.delete(listener);
};

export const trackRequestStart = (config = {}) => {
  if (config.skipGlobalLoading) {
    config.__trackedLoading = false;
    return config;
  }

  config.__trackedLoading = true;
  pending += 1;

  const method = String(config.method || 'get').toLowerCase();
  const delay = MUTATING.has(method) ? 0 : GET_DELAY_MS;

  if (delay === 0) {
    if (showTimer) {
      clearTimeout(showTimer);
      showTimer = null;
    }
    setVisible(true);
    return config;
  }

  if (!visible && !showTimer) {
    showTimer = setTimeout(() => {
      showTimer = null;
      if (pending > 0) setVisible(true);
    }, delay);
  }

  return config;
};

export const trackRequestEnd = (config = {}) => {
  if (!config.__trackedLoading) return;

  pending = Math.max(0, pending - 1);

  if (pending === 0) {
    if (showTimer) {
      clearTimeout(showTimer);
      showTimer = null;
    }
    setVisible(false);
  }
};
